import React, {useEffect, useState} from 'react';
import {CardProductCodeName} from "../../constants/Card";
import {useTranslation} from "react-i18next";

type Props = {
    cardProductCode: string;
}

const CardApplyContainer: React.FC<Props> = ({cardProductCode}) => {

    /** 다국어처리 */
    const { t } = useTranslation();

    const [cardStatus, setCardStatus] = useState<number>(5);
    const [content, setContent] = useState<JSX.Element>(<>
        <span>{t(`STAT01.benefit01.${cardProductCode}`)}</span>
        <span>{t(`STAT01.benefit02.${cardProductCode}`)}</span>
        <span>{t(`STAT01.benefit03.${cardProductCode}`)}</span>
    </>);

    useEffect(() => {
        setCardStatus(5);
    }, []);

    useEffect(() => {
        let contentJSX;

        contentJSX = (<dl className="content1">
            <dd>{t(`STAT01.benefit01.${cardProductCode}`)}</dd>
            <dd>{t(`STAT01.benefit02.${cardProductCode}`)}</dd>
            <dd>{t(`STAT01.benefit03.${cardProductCode}`)}</dd>
        </dl>);

        setContent(contentJSX);
    }, [t, cardProductCode]);

    return (
        <div className="cardWrap3">
            <div className="img">
                <img src={`/assets/images/content/gmoney-card_${cardProductCode}${[1,2].includes(cardStatus) ? "_disabled" : ""}.png?v=0`}
                     alt={CardProductCodeName[Number(cardProductCode)]}
                />
            </div>
            <section>
                <div className="cardTitle">{CardProductCodeName[Number(cardProductCode)]}</div>
                {content}
            </section>
        </div>
    );
};

export default CardApplyContainer;
